export const splitViewGoToBarDefaultSettings = {
    show: false,
    targetContent: null,
    targetContentName: null,
};
